module.exports = __webpack_public_path__ + "static/media/INGRESAR.c1b3b9e0.svg";